import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { modalActions } from '../../redux/root-action';
import { getDomain } from '../../utils/api';
import { analyticsTracking } from 'utils/constants';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 20px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
  padding: 32px 0 24px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
    padding: 32px 0;
  }
`;

const StyledRow = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

const IconContainer = styled.div`
  // flex: 1;
`;

const IconText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey900};
`;

const IconTextHeader = styled.div`
  font-family: Nimbus Sans Bold;
`;

const StyledImage = styled.img`
  margin-right: 24px;
`;

const BottomText = styled.div`
  margin-bottom: 56px;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;
class TermedModal extends Component<any, any> {
  handleGetMoreDetails = () => {
    const { accounts } = this.props;
    const planNumber = accounts[0].planNumber;

    window.location.href =
      getDomain() + '/rps/rws/account/participant/transactions/distributions.otc?accountKey=RPS_' + planNumber;
  };

  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Choose the right course for your money.'} showClose={true} />
        <ReactModalContent>
          <StyledText>You have options for the retirement plan savings from your old job.</StyledText>
          <StyledRow>
            <IconContainer>
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconCircleVault}`} alt="vault icon" />
            </IconContainer>
            <IconText>
              <IconTextHeader>Keep it where it is</IconTextHeader>
              Your money can grow tax-deferred, but you cannot make additional contributions.
            </IconText>
          </StyledRow>
          <StyledRow>
            <IconContainer>
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconCircleRollover}`} alt="rollover icon" />
            </IconContainer>
            <IconText>
              <IconTextHeader>Roll over to an IRA</IconTextHeader>
              You money will remain tax-deferred and you can choose to make additional contributions.
            </IconText>
          </StyledRow>
          <StyledRow>
            <IconContainer>
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconCircleEmployee}`} alt="employee icon" />
            </IconContainer>
            <IconText>
              <IconTextHeader>Roll over to a new employer</IconTextHeader>
              If you have a new employer that accepts rollovers, you can continue to contribute to your account,
              tax-deferred.
            </IconText>
          </StyledRow>
          <StyledRow>
            <IconContainer>
              <StyledImage src={`data:image/svg+xml;base64,${tokens.AssetIconCircleMoney}`} alt="money icon" />
            </IconContainer>
            <IconText>
              <IconTextHeader>Cash out </IconTextHeader>
              You can withdraw the money, but you will owe taxes and possible penalties.
            </IconText>
          </StyledRow>
          <BottomText>
            When deciding between an employer-sponsored plan and an IRA, there may be important differences to
            consider-such as range of investment options, fees and expenses, availability of services, and distribution
            rules (including differences in applicable taxes and penalties). Depending on your plan&#39;s investment
            options, in some cases, the investment management fees associated with your plan&#39;s investment options
            may be lower than similar investment options offered outside the plan.
          </BottomText>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Get More Details"
          handleCTAClick={this.handleGetMoreDetails}
          hideCancel={true}
          CTAButtonId={analyticsTracking.RIXActionTileKnowYourOptionsMoreDetails}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  //eslint-disable-next-line
  const { accounts } = state;

  return {
    accounts: state.riScenario.accounts,
  };
};

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
})(TermedModal);
